export default {
  SET_BOOKING_DETAIL: 'SET_BOOKING_DETAIL',
  SET_ALL_BOOKING_DETAIL: 'SET_ALL_BOOKING_DETAIL',
  RESET_ALL_MEETING_INFO: 'RESET_ALL_MEETING_INFO',
}
